export const useAppNetworkOnline = () => useState<boolean>("app-network-online", () => true);
